import React, { PureComponent } from 'react';
import { connect } from 'unistore/react';

import Switch from '~/core/scripts/components/Switch';

import { Actions } from '../../Store';

import './BrexitToggle.styl';

class BrexitToggle extends PureComponent {
  handleBrexit = (brexit) => {
    this.props.setBrexit(brexit);
  }

  render() {
    const { dataIndex, data, brexit } = this.props;

    if (dataIndex < data.length - 1) {
      return null;
    }

    return (
      <div className="brexit-toggle">
        <div className="brexit-toggle__title">Brexit-Check</div>
        <div className="brexit-toggle__switchbox">
          <div className="brexit-toggle__left">Mit Großbritanien</div>
          <Switch checked={brexit} onChange={this.handleBrexit} />
          <div className="brexit-toggle__right">Ohne Großbritanien</div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  brexit: state.brexit,
  dataIndex: state.dataIndex,
  data: state.data
}), Actions)(BrexitToggle);
